<template>
  <v-row class="pl-3 ma-0">
    <v-col class="pa-0">
      <v-card elevation="0">
        <v-toolbar flat color="secondary" density="compact">
          <v-toolbar-title>
            <v-breadcrumbs v-model:items="breadcrumbs" active-class="text-disabled" class="text-md-body-1 text-subtle pa-0">
              <template #divider v-if="!generic_page && current">
                <span class="text-subtle">/</span>
              </template>
            </v-breadcrumbs>
          </v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row v-if="!generic_page && !current" no-gutters align="start" class="bg-secondary pl-6">
          <v-col>
            <h1 class="text-h3 text-primary">{{ $store.getters.translate(page.name) }}</h1>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";

export default {
  name: "BaseBreadcrumb",
  props: ["page", "current", "generic_page"],
  data() {
    return {
      breadcrumbs: [],
    };
  },
  created() {
    this.breadcrumbs = helpFunctions.getBreadcrumbs(this.page.name, this.current);
  },
  watch: {
    current: {
      handler() {
        this.breadcrumbs = helpFunctions.getBreadcrumbs(this.page.name, this.current);
      },
    },
  },
};
</script>